import { render, staticRenderFns } from "./ConventionTeaser.vue?vue&type=template&id=361e916a&scoped=true"
import script from "./ConventionTeaser.vue?vue&type=script&lang=js"
export * from "./ConventionTeaser.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaser.vue?vue&type=style&index=0&id=361e916a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e916a",
  null
  
)

export default component.exports